export const USERS = {
  "admin@example.com": {
    password: "admin123",
    role: "admin",
  },
  "manager@example.com": {
    password: "manager123",
    role: "manager",
  },
  "viewer@example.com": {
    password: "viewer123",
    role: "viewer",
  },
};
